export default {
    CAMPAIGNS_FOOTER_LOGO: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/Products-%20logos/camp_logo.svg"
};
